import { gql } from "@apollo/client";
import { useSuspenseQuery } from "@apollo/client/react";

import Pricelists from "./Pricelists.graphql";

export type Currency = "EUR" | "CZK" | "CHF" | "RON" | "RSD" | "HUF" | "BGN";
export type PriceType = "ISSUE" | "UNIT";

export interface IPrice {
    id: string;
    pricelistID: string;
    productID: string;
    basicUnitOfMeasurement: string | null;
    calculationUnitOfMeasurement: string | null;
    unitOfIssue: string | null;
    quantityPerIssue: number | null;
    roundToPiece: number | null;
    roundToPackage: number | null;
    roundToPalette: number | null;
    disablePackageRounding: boolean | null;
    vat: number | null;
    valid: { from: string | null; to: string | null } | null;
    type: PriceType;
    value: number | null;
}

export interface IPricelist {
    id: string
    brandID: string
    name: { language: string; text: string }[]
    currency: Currency
    countries: string[] | null
    defaultForCountries: string[] | null
    valid: { from: string | null; to: string | null } | null
    archived: boolean
    productCount: number
}

export default function usePricelists(brandID: string, archived?: boolean) {
    return useSuspenseQuery<{ pricelists: IPricelist[] }>(
        gql(Pricelists),
        {
            variables: { brandID, archived },
        },
    );
}
